import { message } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Card, Form, FormGroup, Modal, ModalBody, Spinner } from "reactstrap";
import { AllowAccess } from "../../../components/BlockAccess";
import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PaginationComponent,
  RSelect,
  TenorTable,
} from "../../../components/Component";
import DeleteModal from "../../../components/DeleteModal/DeleteModal";
import { authHeader } from "../../../header";
import { useDebounce } from "../../../hooks/useDebounceSearch";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { statusOptions } from "../options_common";

export const TenorManagement = () => {
  const [modal, setModal] = useState({
    edit: false,
    add: false,
    view: false,
  });
  const [editId, setEditedId] = useState();
  const [formData, setFormData] = useState({
    interestFormula: 0,
    interestOption: 0,
    tenorDays: 0,
    tenorDescription: "",
    tenorDisplayIn: "IN_DAYS",
    tenorMonths: 0,
    tenorWeeks: 0,
    tenorName: "",
    tenorStatus: "ACTIVE",
    tenorYears: 0,
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(7);
  const [productTenor, setProductTenor] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadBtn, setIsLoadBtn] = useState(false);
  const [details, setDetails] = useState({});
  const [tenorMonths, settenorMonths] = useState(0);
  const [tenorWeeks, settenorWeeks] = useState(0);
  const [tenorYears, settenorYears] = useState(0);
  const [search, setSearch] = useState("");

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const debouncedSearchTerm = useDebounce(search, 500);

  useEffect(
    () => {
      // if (debouncedSearchTerm) {
      getAllTenors();
      setCurrentPage(1);
      // }v
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedSearchTerm] // Only call effect if debounced search term changes
  );

  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const getMonth = (e) => {
    let days = parseInt(e.target.value);
    let month = Math.floor(days / 30);
    let week = Math.floor(days / 7);
    let year = Math.round(month / 12);

    settenorMonths(month);
    settenorWeeks(week);
    settenorYears(year);
  };

  const getYear = (e) => {
    let month = parseInt(e.target.value);
    let year = Math.round(month / 12);
    settenorYears(year);
  };

  const resetForm = () => {
    setFormData({
      interestFormula: 0,
      interestOption: 0,
      tenorDays: 0,
      tenorDescription: "",
      tenorDisplayIn: "IN_DAYS",
      tenorMonths: 0,
      tenorWeeks: 0,
      tenorName: "",
      tenorStatus: "ACTIVE",
      tenorYears: 0,
    });
    settenorMonths(0);
    settenorYears(0);
    settenorWeeks(0);
  };

  const getAllTenors = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/trtenor?search=${search}`, {
        headers: authHeader(),
      });
      const { data } = await response.data;
      const resultData = data.body;
      if (resultData) {
        setProductTenor(resultData);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const createTenor = async (obj) => {
    const data = {
      ...obj,
      tenorMonths,
      tenorYears,
      tenorWeeks,
    };
    try {
      setIsLoadBtn(true);
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/admin/trtenor`, data, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getAllTenors();
        setIsLoadBtn(false);
        setIsLoading(false);
        message.success({
          content: "Tenor Created Successfully",
          style: {
            marginTop: "20vh",
          },
        });
        resetForm();
      }
    } catch (error) {
      const errMsg = error.response;
      setIsLoadBtn(false);
      setIsLoading(false);
      message.error({
        content: errMsg.data.message,
        style: {
          marginTop: "20vh",
        },
      });
      resetForm();
    }
  };

  const editTenor = async (obj) => {
    const data = {
      ...obj,
      tenorMonths,
      tenorYears,
      tenorWeeks,
    };
    try {
      setIsLoadBtn(true);
      const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/auth/admin/trtenor/${editId}`, data, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getAllTenors();
        setIsLoadBtn(false);
        setIsLoading(false);
        message.success({
          content: "Tenor Edited Successfully",
          style: {
            marginTop: "20vh",
          },
        });
        resetForm();
      }
    } catch (error) {
      const errMsg = error.response;
      setIsLoadBtn(false);
      setIsLoading(false);
      getAllTenors();
      message.error({
        content: errMsg.data.message,
        style: {
          marginTop: "20vh",
        },
      });
      resetForm();
    }
  };

  const deleteTenor = async () => {
    try {
      setIsLoading(true);
      const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/auth/admin/trtenor/${formData.id}`, {
        headers: authHeader(),
      });

      const data = await response.data;
      if (data) {
        getAllTenors();
        setIsLoadBtn(false);
        setIsLoading(false);
        setModal({ delete: false });
        resetForm();
      }
      return { data };
    } catch (error) {
      const errMsg = error.response;
      message.error({
        content: errMsg.data.message,
        style: {
          marginTop: "20vh",
        },
      });
      setIsLoadBtn(false);
      setIsLoading(false);
      getAllTenors();
      setModal({ delete: false });
      resetForm();
    }
  };

  const handleDelete = () => {
    setModal((prev) => ({ ...prev, delete: false }));
    deleteTenor();
  };

  const onFormCancel = () => {
    setModal({ edit: false, add: false });
    setDetails(null);
    resetForm();
  };

  const onFormSubmit = () => {
    createTenor(formData);
    setModal({ add: false });
  };

  const onDeleteClick = (items) => {
    setModal((prev) => ({ ...prev, delete: true }));
    setDetails({
      id: items.id,
      tenorName: items?.tenorName,
    });
  };

  const onEditSubmit = () => {
    editTenor(formData);
    setModal({ edit: false });
  };

  const onEditClick = async (items) => {
    setModal({ edit: true });
    setFormData({
      tenorName: items.tenorName,
      tenorStatus: items.tenorStatus,
      tenorDescription: items.tenorDescription,
      tenorDays: items.tenorDays,
      tenorWeeks: items.tenorWeeks,
      tenorMonths: items.tenorMonths,
      tenorYears: items.tenorYears,
      id: items.id,
    });
    settenorYears(items.tenorYears);
    settenorMonths(items.tenorMonths);
    settenorWeeks(items.tenorWeeks);
    setEditedId(items.id);
  };

  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = productTenor?.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const { errors, register, handleSubmit } = useForm();

  useEffect(() => {
    getAllTenors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <Head title="Tenor Management" />
      <Content>
        <Block size="lg">
          <BlockHead>
            <BlockHeadContent>
              <div className="d-flex justify-content-between align-items-center">
                <BlockTitle tag="h4">Tenor Management</BlockTitle>
                <div className="d-flex align-items-center justify-center">
                  <div className="mr-2">
                    <input
                      className="form-control"
                      value={search}
                      onChange={handleSearchChange}
                      placeholder="Search Tenor..."
                    />
                  </div>
                  <AllowAccess allowedRights={["CREATE_TENOR"]}>
                    <Button color="primary" onClick={() => setModal({ add: true })}>
                      <Icon name="plus" />
                      <span>Add Tenor</span>
                    </Button>
                  </AllowAccess>
                </div>
              </div>
            </BlockHeadContent>
          </BlockHead>
          <Card className="card-bordered card-preview">
            {isLoading ? (
              <Spinner
                color="primary"
                style={{
                  height: "3rem",
                  width: "3rem",
                  margin: "0 auto",
                }}
              />
            ) : (
              <TenorTable
                productTenor={currentItems}
                modal={modal}
                onEditClick={onEditClick}
                handleView={() => setModal({ view: true })}
                handleDel={onDeleteClick}
              />
            )}
          </Card>
          <div className="card-inner">
            {productTenor && productTenor.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={productTenor.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No Product Tenor found</span>
              </div>
            )}
          </div>
        </Block>

        <Modal isOpen={modal.add} toggle={() => setModal({ add: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm" />
            </a>
            <div className="p-2">
              <h5 className="title">Add Product Tenor</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)}>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Tenor Name</label>
                      <input
                        type="text"
                        name="tenorName"
                        placeholder="Tenor Name"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.tenorName && <span className="invalid">{errors.tenorName.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <RSelect
                        options={statusOptions}
                        onChange={(e) => setFormData({ ...formData, status: e.value })}
                      />
                      {errors.tenorStatus && <span className="invalid">{errors.tenorStatus.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Days</label>
                      <input
                        type="number"
                        name="tenorDays"
                        placeholder="Days"
                        onChange={(e) => {
                          getMonth(e);
                          setFormData({ ...formData, tenorDays: parseInt(e.target.value) });
                        }}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.tenorDays && <span className="invalid">{errors.tenorDays.message}</span>}
                    </FormGroup>
                  </Col>
                  {/* <Col md="6">
                    <FormGroup>
                      <label className="form-label">Weeks</label>
                      <input
                        type="number"
                        name="tenorWeeks"
                        value={tenorWeeks}
                        onChange={(e) => {
                          settenorWeeks(e.target.value);
                          setFormData({ ...formData, tenorWeeks: tenorWeeks });
                        }}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.tenorWeeks && <span className="invalid">{errors.tenorWeeks.message}</span>}
                    </FormGroup>
                  </Col> */}
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Months</label>
                      <input
                        type="number"
                        name="tenorMonths"
                        value={tenorMonths}
                        placeholder="Months"
                        onChange={(e) => {
                          settenorMonths(e.target.value);
                          getYear(e);
                          setFormData({ ...formData, tenorMonths: parseInt(e.target.value) });
                        }}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.tenorMonths && <span className="invalid">{errors.tenorMonths.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Years</label>
                      <input
                        type="number"
                        name="tenorYears"
                        placeholder="Years"
                        value={tenorYears}
                        onChange={(e) => {
                          settenorYears(e.target.value);
                          setFormData({ ...formData, tenorYears: parseInt(e.target.value) });
                        }}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.tenorYears && <span className="invalid">{errors.tenorYears.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col size="12">
                    <FormGroup>
                      <label className="form-label">Description</label>
                      <textarea
                        name="tenorDescription"
                        value={formData.tenorDescription}
                        placeholder="Tenor Description"
                        onChange={(e) => onInputChange(e)}
                        className="form-control-xl form-control no-resize"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.tenorDescription && <span className="invalid">{errors.tenorDescription.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        {isLoadBtn ? (
                          <Button color="primary" disabled>
                            <Spinner size="sm">Loading...</Spinner>
                            <span> Loading</span>
                          </Button>
                        ) : (
                          <Button color="primary" size="md" type="submit">
                            Submit
                          </Button>
                        )}
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={modal.edit} toggle={() => setModal({ edit: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm" />
            </a>
            <div className="p-2">
              <h5 className="title">Edit Tenor</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onEditSubmit)}>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Tenor Name</label>
                      <input
                        type="text"
                        name="tenorName"
                        value={formData.tenorName}
                        placeholder="Tenor Name"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <RSelect
                        defaultValue={statusOptions.find((d) => d.value === String(formData.tenorStatus))}
                        options={statusOptions}
                        onChange={(e) => setFormData({ ...formData, tenorStatus: e.value })}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Days</label>
                      <input
                        type="number"
                        name="tenorDays"
                        value={formData.tenorDays}
                        placeholder="Days"
                        onChange={(e) => {
                          getMonth(e);
                          setFormData({ ...formData, tenorDays: parseInt(e.target.value) });
                        }}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.tenorDays && <span className="invalid">{errors.tenorDays.message}</span>}
                    </FormGroup>
                  </Col>
                  {/* <Col md="6">
                    <FormGroup>
                      <label className="form-label">Weeks</label>
                      <input
                        type="number"
                        name="tenorWeeks"
                        value={tenorWeeks}
                        onChange={(e) => {
                          settenorWeeks(e.target.value);
                          setFormData({ ...formData, tenorWeeks: tenorWeeks });
                        }}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.tenorWeeks && <span className="invalid">{errors.tenorWeeks.message}</span>}
                    </FormGroup>
                  </Col> */}
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Months</label>
                      <input
                        type="number"
                        name="tenorMonths"
                        value={tenorMonths}
                        placeholder="Months"
                        onChange={(e) => {
                          settenorMonths(e.target.value);
                          getYear(e);
                          setFormData({ ...formData, tenorMonths: tenorMonths });
                        }}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.tenorMonths && <span className="invalid">{errors.tenorMonths.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Years</label>
                      <input
                        type="number"
                        name="tenorYears"
                        placeholder="Years"
                        value={tenorYears}
                        onChange={(e) => {
                          settenorYears(e.target.value);
                          setFormData({ ...formData, tenorYears: tenorYears });
                        }}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.tenorYears && <span className="invalid">{errors.tenorYears.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col size="12">
                    <FormGroup>
                      <label className="form-label">Description</label>
                      <textarea
                        name="tenorDescription"
                        value={formData.tenorDescription}
                        placeholder="Tenor Description"
                        onChange={(e) => onInputChange(e)}
                        className="form-control-xl form-control no-resize"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.tenorDescription && <span className="invalid">{errors.tenorDescription.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        {isLoadBtn ? (
                          <Button color="primary" disabled>
                            <Spinner size="sm">Loading...</Spinner>
                            <span> Loading</span>
                          </Button>
                        ) : (
                          <Button color="primary" size="md" type="submit">
                            Update
                          </Button>
                        )}
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <DeleteModal
          isOpen={modal.delete}
          onClose={() => setModal((prev) => ({ ...prev, delete: false }))}
          title={details?.tenorName}
          deleteFunc={() => handleDelete()}
          onFormCancel={onFormCancel}
        />
      </Content>
    </React.Fragment>
  );
};
